import { Component } from '@angular/core';
import { Auth } from 'src/common/security';
import { TranslationManager } from 'src/common/translation';
import { MessagesComponent } from 'src/common/components';
import { Router } from '@angular/router';


@Component({
    selector: 'main-layout',
    templateUrl: './main-layout.component.html'
})
export class MainLayoutComponent {

    translationManager = TranslationManager;
    auth = Auth;
    loggedUserDropdownOpen: boolean = false;
    year = new Date().getFullYear();
    error: string;

    constructor(private router: Router) { }

    logout() {
        Auth.logOut().then(() => {
              this.router.navigate(['/']);
         }).catch((e: any) => {
             this.error = e.error.messages;
             MessagesComponent.instance.showError([this.error]);
         });
    }

    login() {
        this.router.navigate(['/login']);
    }
}
